import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {CustomerProfile} from '../../types/CustomerSocialLogin';
import {getCustomerProfile} from '../../+state/stores.selectors';
import {filter} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Utils} from '../../../../stores/utils/Utils';

@Component({
  selector: 'app-select-address-dialog',
  templateUrl: './select-address-dialog.component.html',
  styleUrl: './select-address-dialog.component.scss'
})
export class SelectAddressDialogComponent implements OnInit, OnDestroy {

  unsubscribe$: Subject<void> = new Subject<void>();
  customerProfile: CustomerProfile;
  selectedAddressId: number | null = null;

  constructor(
    private store: Store<any>,
    private dialogRef: MatDialogRef<SelectAddressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit(): void {
    this.store
      .select(getCustomerProfile)
      .pipe(
        filter(customerProfile => !!customerProfile),
      )
      .subscribe((customerProfile: CustomerProfile) => {
        this.customerProfile = customerProfile;
        if (customerProfile?.addresses?.length > 0) {
          const addresses = customerProfile.addresses;
          if (this.data?.selectedAddressId && addresses.some(addr => addr.id === this.data.selectedAddressId)) {
            this.selectedAddressId = this.data.selectedAddressId;
          } else {
            const main = addresses.find(addr => addr.isMain);
            this.selectedAddressId = main ? main.id : addresses[0].id;
          }
        }
      });
  }

  formatAddress(address) {
    return Utils.formatAddress(address);
  }

  submitSelectedAddress() {
    const address = this.customerProfile.addresses.find(addr => addr.id === this.selectedAddressId);
    this.dialogRef.close(address);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
